import React from "react";
import { useUrlSearchParams } from "../../../commons/hooks/useUrlSearchParams.js";
import {
  parseOnboardingFlowStage,
  type OnboardingFlowStage,
} from "./onboardingFlowStage.js";

export const ONBOARDING_FLOW_URL_SEARCH_PARAM = "ofs";

export function useOnboardingFlow() {
  const { urlSearchParams, setUrlSearchParams } = useUrlSearchParams();

  const onboardingFlowStageUrlSearchParam = urlSearchParams.get(
    ONBOARDING_FLOW_URL_SEARCH_PARAM
  );
  const onboardingFlowStage = parseOnboardingFlowStage(
    onboardingFlowStageUrlSearchParam
  );

  const setOnboardingFlowStage = React.useCallback(
    (newStage: OnboardingFlowStage | null) => {
      if (newStage) {
        setUrlSearchParams({
          [ONBOARDING_FLOW_URL_SEARCH_PARAM]: newStage,
        });
      } else {
        setUrlSearchParams({}, [ONBOARDING_FLOW_URL_SEARCH_PARAM]);
      }
    },
    [setUrlSearchParams]
  );

  return {
    onboardingFlowStage,
    setOnboardingFlowStage,
  };
}
